module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_barco-34f043b9ab62708bd38edc4b65171cd2.png";